<template>

    <div ref="card" id="card-element"></div>

</template>

<style scoped lang="scss">

    .StripeElement {
        background-color: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        box-shadow: none;
        box-sizing: border-box;
        padding: 15px;
        transition: border-color .3s;
    }
    .StripeElement--focus {
        border-color: $color-text;
    }
    .StripeElement--invalid {
        border-color: $color-danger;
    }
    .StripeElement--webkit-autofill {
        background-color: #fff !important;
    }

</style>

<script>

export default {

    computed: {

        stripe() {
            return this.$store.getters['stripe/stripe'];
        },

    },

    mounted() {
        this.initStripe();
    },

    methods: {

        initStripe() {
            let style = {
                base: {
                    color: '#222',
                    fontFamily: '"Montserrat", sans-serif',
                    fontWeight: 500,
                    fontSize: '13px',
                    '::placeholder': {
                        color: '#666'
                    },
                },
            };
            let card = this.stripe.elements().create('card', {
                style: style,
            });
            card.mount(this.$refs.card);
            this.$store.commit('stripe/setCard', card);
            card.addEventListener('change', (event) => {
                if (event.error) {
                    this.$emit('error', event.error.message);
                }
            });
        },

    },

}

</script>